import { render } from "./blogs.vue?vue&type=template&id=753c3d4b&scoped=true"
import script from "./blogs.vue?vue&type=script&lang=js"
export * from "./blogs.vue?vue&type=script&lang=js"

import "./blogs.vue?vue&type=style&index=0&id=753c3d4b&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753c3d4b"]])

export default __exports__